import React from 'react'
import PropTypes from 'prop-types'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'

const CircleAddButton = ({
  centered,
  style,
  ...props
}) => {
  const button = (
    <FloatingActionButton
      key={'add-button'}
      mini
      style={{
        marginTop: '1rem',
        ...style,
      }}
      {...props}
    >
      <ContentAdd />
    </FloatingActionButton>
  )
  return (
    centered ?
      (
        <div style={{ textAlign: 'center' }}>
          {button}
        </div>
      ) : button
  )
}

CircleAddButton.propTypes = {
  centered: PropTypes.bool,
  style: PropTypes.object,
}
CircleAddButton.defaultProps = {
  centered: true,
  style: {},
}

export default CircleAddButton



// WEBPACK FOOTER //
// ./src/components/Button/CircleAddButton.js